export default {"src":"/pro/_next/static/media/qqq.e5ca33bd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};